import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Alert, message } from "antd";
import {
  FaShare,
  FaTimes,
  FaFileAlt,
  FaCheckCircle,
  FaExclamationTriangle,
  FaSignature,
  FaUserTie,
  FaTrash,
  FaPaperPlane,
} from "react-icons/fa";
import SignaturePad from "react-signature-canvas";

function TimesheetSignature({
  isOpen,
  onClose,
  errorDates,
  messages,
  userallroster,
}) {
  const userStr = JSON.parse(localStorage.getItem("users"));
  const apiurl = "https://jlmining.app/api/coverageTimeSheet/";
  const [activeTimeSheetIndex, setActiveTimeSheetIndex] = useState(null);
  const [coverageTimesheet, setCoverageTimesheet] = useState([]);
  const [loading, setLoading] = useState(true);
  const [weekd, setweekd] = useState(false);
  const [weekdetails, setweekdetails] = useState([]);
  const [activeindex, setactiveindex] = useState("");
  const [weekarrdata, setweekarrdata] = useState([]);
  const [signatureDataURL, setSignatureDataURL] = useState("");
  const [RosterId, setRosterId] = useState("");
  const [valueemployee, setvalueemployee] = useState("");
  const [clname, setclname] = useState("");
  const canvasRef = useRef(null);
  const [signerror, setsignerror] = useState(false);
  const [supererror, setsupererror] = useState(false);
  const [supervisorName, setSupervisorName] = useState("");
  const [clientlist, setclientlist] = useState([]);
  const [openTimesheet, setopenTimesheet] = useState(false);
  useEffect(() => {
    const activeRosterRow = userallroster.find(
      (r) => r.active_roster === "Yes"
    );
    if (userallroster.length > 0) {
      getAllclientRoster(activeRosterRow.id);
    }
    if (isOpen) {
      //getCoverageTimeSheet();
    }
  }, [isOpen]);
  const getAllclientRoster = (rosterId) => {
    let formData = {
      rosterId: rosterId,
    };
    axios
      .post(apiurl + "getAllclientRoster", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const alldata = res.data.results;

        setclientlist(alldata);
      })
      .catch((err) => {
        console.error("Error fetching timesheet data:", err);
        // setLoading(false);
      });
  };
  const clearCanvas = () => {
    canvasRef.current.clear();
    setsignerror(false);
  };

  const getCoverageTimeSheet = (clientid, location_id) => {
    setLoading(true);
    const activeRoster = userallroster.filter((r) => r.active_roster === "Yes");
    const activeRosterTypes = activeRoster.map((r) => r.type);

    let formData = {
      user_id: userStr[0].id,
      rostertype: activeRosterTypes[0],
      client_id: clientid,
      roster_id: activeRoster[0].id,
      location_id: location_id,
    };
    axios
      .post(apiurl + "getCoverageTimeSheet", formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        const alldata = res.data.arr;

        setCoverageTimesheet(alldata);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching timesheet data:", err);
        setLoading(false);
      });
  };

  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleShare = (timesheet) => {
    console.log("Sharing timesheet:", timesheet);
  };

  const getuserweeklydata = (
    index,
    start,
    end,
    user_id,
    rosterid,
    locationid,
    client_id
  ) => {
    let data = {
      start: start,
      end: end,
      user_id: user_id,
      rosterid: rosterid,
      locationid: locationid,
      client_id: client_id,
    };

    setvalueemployee({
      user_id: user_id,
      location_id: locationid,
      client_id: client_id,
      roster_id: rosterid,
    });
    setRosterId(rosterid);
    setactiveindex(null);
    setActiveTimeSheetIndex(index);
    setweekarrdata(data);
    setweekd(true);
    axios
      .post(apiurl + "getWeeklyDataTimesheet", data, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (res.data.data.length > 0) {
          //setweekd(true);
          setweekdetails(res.data.data);
        } else {
          //setweekd(false);
        }
      })
      .catch((err) => {});
  };

  const handleformsubmit = (event) => {
    event.preventDefault();
    const vl = event.target;
    const canvas = canvasRef.current;
    const signatureData = canvas.toDataURL(); // Convert canvas to image data URL

    if (canvasRef.current.isEmpty()) {
      setsignerror(true);
      return;
    } else {
      setsignerror(false);
    }
    if (vl.super_viser.value === "") {
      setsupererror(true);
      return;
    } else {
      setsupererror(false);
    }

    setSignatureDataURL(signatureData);

    if (valueemployee.client_id) {
      let formdata = {
        client_id: valueemployee.client_id,
        user_id: valueemployee.user_id,
        start: weekarrdata.start,
        end: weekarrdata.end,
        location_id: valueemployee.location_id,
        signature_img: signatureData,
        super_viser: vl.super_viser.value,
        rosterid: RosterId,
      };

      axios
        .post(apiurl + "employeAttendanceForm", formdata, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.status == "2") {
            message.error("Some thing went wrong, Please try again");
          } else {
            message.success("You are successfully submitted your Time Sheet");
          }
          let senddata = {
            email: "",
            name: valueemployee.super_viser,
            message: "",
            start_date: weekarrdata.start,
            end_date: weekarrdata.end,
            user_id: valueemployee.user_id,
            roster_id: valueemployee.roster_id,
            RosterId: RosterId,
            client_id: valueemployee.client_id,
            location_id: valueemployee.location_id,
          };
          insertSign(senddata);
          setTimeout(() => {
            window.location.reload();
          }, 4500);
        })
        .catch((err) => {});
    }
  };
  const insertSign = (senddata) => {
    axios
      .post(apiurl + "sendtimeSheetForUserEnd", senddata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => {})
      .catch((err) => {});
  };
  const handlegetClient = (e) => {
    if (e.target.value === "") {
      setopenTimesheet(false);
      return;
    }

    const { client_id, location_id } = JSON.parse(e.target.value);
    console.log("client_id:", client_id, "location_id:", location_id);

    setweekdetails([]);
    setweekd(false);
    setopenTimesheet(true);

    getCoverageTimeSheet(client_id, location_id); // now you have both
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <div className="modal-title">
            <FaFileAlt className="title-icon" />
            <h2>Timesheet Signature</h2>
          </div>
          <button className="close-button" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {/* Message Alert */}

        {/* Timesheet List */}
        <div className="timesheet-content">
          <label className="mb-2">Client</label>
          <select className="form-control mb-4" onChange={handlegetClient}>
            <option value="">--Select Client--</option>
            {clientlist.map((client) => (
              <option
                key={client.client_id}
                value={JSON.stringify({
                  client_id: client.client_id,
                  location_id: client.location_id,
                })}
              >
                {client.client_name}
              </option>
            ))}
          </select>
          {openTimesheet && (
            <h3 className="timesheet-subtitle">Available Timesheets</h3>
          )}
          {openTimesheet && (
            <>
              {loading ? (
                <div className="loading-state">
                  <div className="loading-spinner"></div>
                  <p>Loading timesheets...</p>
                </div>
              ) : coverageTimesheet && coverageTimesheet.length > 0 ? (
                <div className="timesheet-list">
                  {coverageTimesheet.map((item, index) => (
                    <div
                      key={index}
                      className={`timesheet-item ${
                        index === activeTimeSheetIndex ? "active" : ""
                      }`}
                      onClick={() =>
                        getuserweeklydata(
                          index,
                          item.start,
                          item.end,
                          item.user_id,
                          item.roster_id,
                          item.location_id,
                          item.client_id
                        )
                      }
                    >
                      <div className="timesheet-info">
                        <span className="timesheet-dates">
                          Time sheet from {formatDate(item.start)} -{" "}
                          {formatDate(item.end)}
                        </span>
                        {index === activeTimeSheetIndex && weekd && (
                          <div className="timesheet-status">
                            <span className="status-badge">
                              Ready for signature
                            </span>
                          </div>
                        )}
                      </div>
                      <button
                        className="share-button"
                        type="button"
                        title="Share"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleShare(item);
                        }}
                      >
                        <FaShare />
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="empty-state">
                  <FaFileAlt className="empty-icon" />
                  <p>No timesheets available</p>
                </div>
              )}
            </>
          )}
          {weekd && (
            <div className="timesheet-details-section">
              <div className="section-header">
                <h3>Timesheet Details</h3>
                <div className="date-range">
                  {formatDate(weekarrdata.start)} -{" "}
                  {formatDate(weekarrdata.end)}
                </div>
              </div>

              <div className="timesheet-table-container">
                <table className="timesheet-table">
                  <thead>
                    <tr>
                      <th>Client Name</th>
                      <th>Day</th>
                      <th>Date</th>
                      <th>Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(weekdetails) && weekdetails.length > 0 ? (
                      weekdetails.map((item, index) => (
                        <tr key={index}>
                          <td>{item.name}</td>
                          <td>{item.dd}</td>
                          <td>{item.nd}</td>
                          <td className="hours-cell">{item.hours}</td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="no-data">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {weekdetails.length > 0 && (
                    <tfoot>
                      <tr>
                        <td colSpan="4" className="total-label">
                          Total Hours
                        </td>
                        <td className="total-hours">
                          {weekdetails.reduce(
                            (sum, item) => sum + parseFloat(item.hours || 0),
                            0
                          )}
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>

              {weekdetails.length > 0 && (
                <form
                  onSubmit={handleformsubmit}
                  className="signature-form"
                  method="post"
                >
                  <input
                    type="hidden"
                    name="client_id"
                    value={valueemployee.client_id}
                  />
                  <input
                    type="hidden"
                    name="attend_id"
                    value={valueemployee.id}
                  />
                  <input
                    type="hidden"
                    name="user_id"
                    value={valueemployee.user_id}
                  />
                  <input
                    type="hidden"
                    name="hours"
                    value={valueemployee.hours}
                  />
                  <div className="form-section">
                    <div className="section-title">
                      <FaSignature />
                      <span>Supervisor Signature</span>
                    </div>

                    <div
                      className={`signature-container ${
                        signerror ? "error" : ""
                      }`}
                    >
                      <SignaturePad
                        ref={canvasRef}
                        canvasProps={{
                          className: "signature-canvas",
                          style: {
                            background: "#f9fafb",
                            borderRadius: "4px",
                          },
                        }}
                      />
                      <div className="signature-actions">
                        <button
                          type="button"
                          onClick={clearCanvas}
                          className="action-btn clear-btn"
                        >
                          <FaTrash /> Clear
                        </button>
                      </div>
                    </div>
                    {signerror && (
                      <div className="error-message">Signature is required</div>
                    )}
                  </div>

                  <div className="form-section">
                    <label htmlFor="supervisorName" className="input-label">
                      Supervisor Name <span className="required">*</span>
                    </label>
                    <input
                      id="supervisorName"
                      type="text"
                      name="super_viser"
                      value={supervisorName}
                      onChange={(e) => {
                        setSupervisorName(e.target.value);
                        setsupererror(false);
                      }}
                      className={`text-input ${supererror ? "error" : ""}`}
                      placeholder="Enter supervisor name..."
                    />
                    {supererror && (
                      <div className="error-message">
                        Supervisor name is required
                      </div>
                    )}
                  </div>

                  <div className="form-actions">
                    <button
                      type="button"
                      onClick={onClose}
                      className="btn-secondary"
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn-primary">
                      <FaPaperPlane /> Submit Timesheet
                    </button>
                  </div>
                </form>
              )}
            </div>
          )}
        </div>

        <style jsx>{`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1300;
            padding: 20px;
          }

          .modal-container {
            position: relative;
            background-color: white;
            border-radius: 12px;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
              0 10px 10px -5px rgba(0, 0, 0, 0.04);
            width: 100%;
            max-width: 800px;
            max-height: 90vh;
            overflow: auto;
            display: flex;
            flex-direction: column;
          }

          .modal-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 24px;
            border-bottom: 1px solid #e5e7eb;
            background: #f9fafb;
            border-radius: 12px 12px 0 0;
          }

          .modal-title {
            display: flex;
            align-items: center;
            gap: 12px;
          }

          .modal-title h2 {
            margin: 0;
            font-size: 20px;
            font-weight: 600;
            color: #1f2937;
          }

          .title-icon {
            font-size: 24px;
            color: #3b82f6;
          }

          .close-button {
            background: none;
            border: none;
            font-size: 18px;
            cursor: pointer;
            color: #6b7280;
            padding: 8px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
          }

          .close-button:hover {
            background-color: #f3f4f6;
            color: #374151;
          }

          .alert-box {
            border-radius: 8px;
            padding: 16px;
            margin: 0 24px;
            margin-top: 16px;
          }

          .alert-box.error {
            background-color: #fef2f2;
            border: 1px solid #fecaca;
          }

          .alert-box.success {
            background-color: #f0fdf4;
            border: 1px solid #bbf7d0;
          }

          .alert-content {
            display: flex;
            align-items: flex-start;
            gap: 12px;
          }

          .alert-icon {
            font-size: 20px;
            margin-top: 2px;
            flex-shrink: 0;
          }

          .alert-icon.error {
            color: #dc2626;
          }

          .alert-icon.success {
            color: #059669;
          }

          .alert-content p {
            margin: 0;
            color: inherit;
            line-height: 1.5;
            font-weight: 500;
          }

          .timesheet-content {
            padding: 24px;
            flex: 1;
            overflow-y: auto;
          }

          .timesheet-subtitle {
            margin: 0 0 16px 0;
            font-size: 18px;
            font-weight: 600;
            color: #374151;
          }

          .timesheet-list {
            display: flex;
            flex-direction: column;
            gap: 12px;
            margin-bottom: 24px;
          }

          .timesheet-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px;
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s;
          }

          .timesheet-item:hover {
            border-color: #3b82f6;
            background-color: #f8fafc;
          }

          .timesheet-item.active {
            border-color: #3b82f6;
            background-color: #eff6ff;
          }

          .timesheet-info {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 4px;
          }

          .timesheet-dates {
            font-weight: 500;
            color: #1f2937;
          }

          .timesheet-status {
            display: flex;
            align-items: center;
          }

          .status-badge {
            font-size: 12px;
            padding: 4px 8px;
            background-color: #10b981;
            color: white;
            border-radius: 4px;
          }

          .share-button {
            background: none;
            border: none;
            font-size: 16px;
            cursor: pointer;
            color: #6b7280;
            padding: 8px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
          }

          .share-button:hover {
            color: #3b82f6;
            background-color: #eff6ff;
          }

          .loading-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 0;
            gap: 16px;
          }

          .loading-spinner {
            width: 40px;
            height: 40px;
            border: 4px solid #e5e7eb;
            border-top: 4px solid #3b82f6;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          .empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 0;
            gap: 16px;
            color: #6b7280;
          }

          .empty-icon {
            font-size: 48px;
            opacity: 0.5;
          }

          .timesheet-details-section {
            margin-top: 24px;
            padding-top: 24px;
            border-top: 1px solid #e5e7eb;
          }

          .section-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
          }

          .section-header h3 {
            margin: 0;
            font-size: 18px;
            font-weight: 600;
            color: #1f2937;
          }

          .date-range {
            color: #6b7280;
            font-size: 14px;
          }

          .timesheet-table-container {
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            overflow: hidden;
            margin-bottom: 24px;
          }

          .timesheet-table {
            width: 100%;
            border-collapse: collapse;
          }

          .timesheet-table th {
            background-color: #f9fafb;
            padding: 12px 16px;
            text-align: left;
            font-weight: 600;
            color: #374151;
            border-bottom: 1px solid #e5e7eb;
          }

          .timesheet-table td {
            padding: 12px 16px;
            border-bottom: 1px solid #e5e7eb;
          }

          .timesheet-table tbody tr:last-child td {
            border-bottom: none;
          }

          .hours-cell {
            font-weight: 500;
            color: #1f2937;
          }

          .timesheet-table tfoot {
            background-color: #f9fafb;
          }

          .total-label {
            font-weight: 600;
            text-align: right;
          }

          .total-hours {
            font-weight: 600;
            color: #1f2937;
          }

          .no-data {
            text-align: center;
            color: #6b7280;
            font-style: italic;
          }

          .signature-form {
            display: flex;
            flex-direction: column;
            gap: 24px;
          }

          .form-section {
            display: flex;
            flex-direction: column;
            gap: 12px;
          }

          .section-title {
            display: flex;
            align-items: center;
            gap: 8px;
            font-weight: 600;
            color: #374151;
          }

          .client-info {
            padding: 12px;
            background-color: #f9fafb;
            border-radius: 6px;
            border: 1px solid #e5e7eb;
          }

          .signature-container {
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            overflow: hidden;
          }

          .signature-container.error {
            border-color: #ef4444;
          }

          .signature-canvas {
            width: 100%;
            height: 200px;
            cursor: crosshair;
          }

          .signature-actions {
            padding: 12px;
            background-color: #f9fafb;
            border-top: 1px solid #e5e7eb;
            display: flex;
            justify-content: flex-end;
          }

          .action-btn {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 6px 12px;
            background: none;
            border: 1px solid #e5e7eb;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
            transition: all 0.2s;
          }

          .clear-btn {
            color: #ef4444;
          }

          .clear-btn:hover {
            background-color: #fef2f2;
          }

          .input-label {
            font-weight: 500;
            color: #374151;
          }

          .required {
            color: #ef4444;
          }

          .text-input {
            padding: 10px 12px;
            border: 1px solid #d1d5db;
            border-radius: 6px;
            font-size: 14px;
            transition: all 0.2s;
          }

          .text-input:focus {
            outline: none;
            border-color: #3b82f6;
            box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          }

          .text-input.error {
            border-color: #ef4444;
          }

          .error-message {
            color: #ef4444;
            font-size: 14px;
            margin-top: 4px;
          }

          .form-actions {
            display: flex;
            justify-content: flex-end;
            gap: 12px;
            padding-top: 16px;
            border-top: 1px solid #e5e7eb;
          }

          .btn-primary,
          .btn-secondary {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 10px 20px;
            border: none;
            border-radius: 6px;
            font-weight: 500;
            font-size: 14px;
            cursor: pointer;
            transition: all 0.2s;
          }

          .btn-primary {
            background-color: #3b82f6;
            color: white;
          }

          .btn-primary:hover {
            background-color: #2563eb;
          }

          .btn-secondary {
            background-color: #f3f4f6;
            color: #374151;
            border: 1px solid #d1d5db;
          }

          .btn-secondary:hover {
            background-color: #e5e7eb;
          }

          @media (max-width: 640px) {
            .modal-overlay {
              padding: 10px;
            }

            .modal-header,
            .timesheet-content {
              padding: 16px;
            }

            .alert-box {
              margin: 0 16px;
              margin-top: 12px;
            }

            .section-header {
              flex-direction: column;
              align-items: flex-start;
              gap: 8px;
            }

            .form-actions {
              flex-direction: column;
            }

            .btn-primary,
            .btn-secondary {
              justify-content: center;
            }
          }
        `}</style>
      </div>
    </div>
  );
}

export default TimesheetSignature;
